import { message as antdMessage, type MessageArgsProps } from 'antd'
import { type ReactNode } from 'react'

type ArgsProps = Omit<MessageArgsProps, 'content'>

export function loadingMessage(content: string, args?: ArgsProps) {
  antdMessage.loading({ ...args, content })
}

export function infoMessage(content: string, args?: ArgsProps) {
  antdMessage.info({ ...args, content })
}

export function successMessage(content: ReactNode, args?: ArgsProps) {
  antdMessage.success({ ...args, content })
}

export function warningMessage(content: string, args?: ArgsProps) {
  antdMessage.warning({ ...args, content })
}

export function errorMessage(content: string, args?: ArgsProps) {
  antdMessage.error({ ...args, content })
}
